export default {
    title: 'Version history',
    trigger: 'Version history',
    loading: 'Loading…',
    loadError: 'Could not load history.',
    subtitle: {
        loading: 'Loading previous versions…',
        none: 'No previous versions',
        one: '1 previous version',
        many: '{count} previous versions'
    },
    empty: {
        title: 'No previous versions yet',
        body: 'Versions will appear here after your next save.'
    },
    emptyContent: '(empty)',
    restore: 'Restore this version',
    restoredFrom: 'Restored version from {date}.',
    close: 'Close',
    togglePreview: {
        expand: 'Preview version',
        collapse: 'Collapse preview'
    }
}
